import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { PrimaryLink } from '@qover/molecules';
import { Modal } from './Modal';
import ErrorComplianceIcon from './icons/ErrorComplianceIcon';

const Container = styled(Modal).attrs(() => ({
  role: 'alert',
}))`
  -webkit-overflow-scrolling: touch;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.cardBackground()};
  border-radius: 8px;
  box-shadow: 0 5px 10px 0 ${({ theme }) => theme.colors.textQuote(0.3)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 940px;
  min-height: 335px;
  padding: 40px 30px;
  svg {
    fill: ${({ theme }) => theme.colors.error()};
    max-width: 60px;
  }

  p {
    color: ${({ theme }) => theme.colors.textQuote()};
    font-size: 15px;
    text-align: center;
  }

  p.text-error {
    color: ${({ theme }) => theme.colors.error()};
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  p.pending-text-error {
    color: ${({ theme }) => theme.colors.textQuote()};
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
`;

type ComplianceErrorModalProps = {
  onCloseClick: () => void;
};

export function ComplianceErrorModal(props: ComplianceErrorModalProps) {
  return (
    <Container hideOverflow onClickOutside={props.onCloseClick}>
      <ErrorComplianceIcon />
      <div>
        <p className="text-error">
          <strong>
            <Trans id="general.complianceCheckFailed.title" />
          </strong>
        </p>
        <p>
          <Trans id="general.complianceCheckFailed.description" />
        </p>
      </div>
      <div>
        <PrimaryLink
          data-test="payment.errorModal.contactUs"
          href="https://qover.com/contact-us"
          onClick={props.onCloseClick}
        >
          <Trans id="general.contactUs" />
        </PrimaryLink>
      </div>
    </Container>
  );
}
